import CompanyReportingView from './CompanyReportingView';

export default CompanyReportingView;
